<template>
  <div class="application-approval">
    <transition name="fade">
      <review
        phase="funding_gate"
        phase_name="Funding Gate"
        v-if="step == 'start'"
      ></review>
    </transition>
    <transition name="fade">
      <complete
        title="Documents Sent"
        body="Thank you for taking out the time to fill out this form! We will review your documents and get back to you as soon as possible."
        btn_text="Your Progress"
        icon="debt"
        v-if="step == 'complete'"
      ></complete>
    </transition>
    <p class="disclaimer">
      <span>Disclaimer message goes here at the bottom.</span>
    </p>
  </div>
</template>

<script>
import Start from "@/components/Application/FundingGateStart";
import ReviewFunding from "@/components/Application/ReviewFunding";
import Complete from "@/components/Application/Complete";

import { db, functions } from "@/config/firebaseInit";

export default {
  name: "funding",
  components: {
    start: Start,
    review: ReviewFunding,
    complete: Complete,
  },
  data() {
    return {
      step: "start",
    };
  },
  mounted() {},
  created() {
    if (this.$store.state.phase != "Funding Gate") {
      this.$store.commit("setPhase", "Funding Gate");
      this.$store.commit("setAnswers", null);
    }
  },
  watch: {
    step() {
      this.$store.commit("setFundingGatePhase", this.step);
    },
  },
};
</script>

<style scoped lang="scss">
.application-approval {
  position: relative;
  min-height: 100vh;
  padding-top: 70px;
  height: auto;
  .disclaimer {
    margin: 0;
    padding-bottom: 15px;
    position: absolute;
    z-index: 2;
    bottom: 0;
    text-align: center;
    width: 100%;
    left: 0;
    background: white;
    border-top: 2px solid rgba(11, 110, 251, 0.2);
    padding-top: 15px;
    span {
      opacity: 0.5;
    }
  }
}
</style>
